import React, {useState, useRef, useEffect} from 'react';
import {View, Text, TouchableOpacity, ActivityIndicator, Switch, TextInput, StyleSheet, FlatList, Image} from 'react-native';
import ArrowImage from '../../../assets/option frame.png';
import ToolTip from '../directPrinting/toolTip';
import dpStyles from '../../style/directPrinting';
import {fontFamily} from '../../helpers/fontFamily';
import ClearBoxCatalogConfirmModal from './ClearBoxCatalogConfirmModal';

export const WEIGHT_TOOLTIP_ID = 'boxChampWeightTooltip';
export const BOX_SCAN_VERIFICATION_TOOLTIP_ID = 'boxChampBoxScanVerificationTooltip';
const WEIGHT_UNIT_OPTIONS = ['oz', 'lb', 'g', 'kg'];

const BoxCatalogView = ({
  count,
  fileName,
  result,
  isUploading,
  onChooseFile,
  onUpload,
  onClearAll,
  isClearing = false,
  weightCheckEnabled,
  defaultWeight,
  weightUnit,
  windowWidth = 1000,
  onToggleWeight,
  boxScanVerification = false,
  isBoxScanVerificationUpdating = false,
  boxScanVerificationError = null,
  onToggleBoxScanVerification,
  onDefaultWeightChange,
  onCommitDefaultWeight,
  onWeightUnitChange,
  activeTollTip,
  handleTollTip,
}) => {
  const canUpload = !!fileName && !isUploading;
  const showTip = activeTollTip === WEIGHT_TOOLTIP_ID;
  const showVerificationTip = activeTollTip === BOX_SCAN_VERIFICATION_TOOLTIP_ID;

  const [unitDropdownOpen, setUnitDropdownOpen] = useState(false);
  const unitDropdownRef = useRef(null);
  const [clearConfirmVisible, setClearConfirmVisible] = useState(false);

  useEffect(() => {
    const handleOutsidePress = event => {
      if (unitDropdownRef.current && !unitDropdownRef.current.contains(event.target)) {
        setUnitDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleOutsidePress);
    return () => document.removeEventListener('mousedown', handleOutsidePress);
  }, []);

  const selectWeightUnit = unit => {
    onWeightUnitChange && onWeightUnitChange(unit);
    setUnitDropdownOpen(false);
  };

  return (
    <View testID="boxcatalog-section" style={styles.card}>
      <Text style={styles.heading}>BoxChamp Box Catalog</Text>

      <Text testID="boxcatalog-count" style={styles.count}>
        {count == null ? '—' : count} box{count === 1 ? '' : 'es'} available
      </Text>

      <View testID="boxchamp-box-scan-verification-settings" style={styles.verificationWrapper}>
        <View style={styles.weightRow}>
          <TouchableOpacity
            testID="boxchamp-box-scan-verification-info"
            onPress={() => handleTollTip && handleTollTip(BOX_SCAN_VERIFICATION_TOOLTIP_ID)}
            style={styles.infoBtn}>
            <i className="icon-info-circled" style={dpStyles.iconInfo}></i>
          </TouchableOpacity>
          {isBoxScanVerificationUpdating ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <Switch
              testID="boxchamp-box-scan-verification-toggle"
              onValueChange={onToggleBoxScanVerification}
              offColor="#5c6e79"
              onColor="#65baea"
              offHandleColor="#969696"
              onHandleColor="#fbfdfe"
              handleDiameter={22}
              uncheckedIcon={false}
              checkedIcon={false}
              height={20}
              width={40}
              value={boxScanVerification}
            />
          )}
          <Text style={styles.weightLabel}>Box scan verification</Text>
          {showVerificationTip && (
            <ToolTip
              testID="boxchamp-box-scan-verification-tooltip"
              windowWidth={windowWidth}
              message="When on, the packer scans each box's barcode before packing into it and to confirm each hand-off. When off, hand-offs are confirmed with the Next Box button or card, and box barcodes are only scanned to record a substitution."
              width={228}
              left={-232}
              top={8}
            />
          )}
        </View>
        {boxScanVerificationError ? (
          <Text testID="boxchamp-box-scan-verification-error" style={styles.errorLine}>
            {boxScanVerificationError}
          </Text>
        ) : null}
      </View>

      {/* BoxChamp weight settings */}
      <View testID="boxchamp-weight-settings" style={styles.weightWrapper}>
        <View style={styles.weightRow}>
          <TouchableOpacity
            testID="boxchamp-weight-check-info"
            onPress={() => handleTollTip && handleTollTip(WEIGHT_TOOLTIP_ID)}
            style={styles.infoBtn}>
            <i className="icon-info-circled" style={dpStyles.iconInfo}></i>
          </TouchableOpacity>
          <Switch
            testID="boxchamp-weight-check-toggle"
            onValueChange={onToggleWeight}
            offColor="#5c6e79"
            onColor="#65baea"
            offHandleColor="#969696"
            onHandleColor="#fbfdfe"
            handleDiameter={22}
            uncheckedIcon={false}
            checkedIcon={false}
            height={20}
            width={40}
            value={weightCheckEnabled}
          />
          <Text style={styles.weightLabel}>Apply weight limits</Text>
          {showTip && (
            <ToolTip
              testID="boxchamp-weight-check-tooltip"
              windowWidth={windowWidth}
              message="When on, BoxChamp keeps items within each box's weight limit, using the default weight below for products that have none. Turn off to ignore weight and choose boxes by size only."
              width={228}
              left={-232}
              top={8}
            />
          )}
        </View>

        {weightCheckEnabled && (
          <View testID="boxchamp-default-weight-section" style={styles.weightSection}>
            <Text style={styles.weightHeading}>Product weight</Text>
            <View style={styles.weightValueRow}>
              <TextInput
                testID="boxchamp-default-weight-input"
                style={styles.weightInput}
                keyboardType="decimal-pad"
                value={defaultWeight}
                onChangeText={onDefaultWeightChange}
                onBlur={onCommitDefaultWeight}
                onSubmitEditing={onCommitDefaultWeight}
              />
              <View ref={unitDropdownRef} style={styles.unitDropdownContainer}>
                <TouchableOpacity
                  testID="boxchamp-default-weight-unit"
                  style={styles.unitDropdownButton}
                  onPress={() => setUnitDropdownOpen(prev => !prev)}>
                  <Text style={styles.unitDropdownText}>{weightUnit || 'oz'}</Text>
                  <Image source={ArrowImage} style={styles.unitDropdownArrow} />
                </TouchableOpacity>
                {unitDropdownOpen && (
                  <View style={styles.unitDropdownPanel}>
                    <FlatList
                      data={WEIGHT_UNIT_OPTIONS}
                      keyExtractor={unit => unit}
                      renderItem={({item: unit}) => {
                        const isSelected = unit === (weightUnit || 'oz');
                        return (
                          <TouchableOpacity
                            testID={`boxchamp-default-weight-unit-option-${unit}`}
                            style={
                              isSelected
                                ? [styles.unitDropdownOption, styles.unitDropdownOptionSelected]
                                : styles.unitDropdownOption
                            }
                            onPress={() => selectWeightUnit(unit)}>
                            <Text
                              style={
                                isSelected
                                  ? [styles.unitDropdownOptionText, styles.unitDropdownOptionTextSelected]
                                  : styles.unitDropdownOptionText
                              }>
                              {unit}
                            </Text>
                          </TouchableOpacity>
                        );
                      }}
                    />
                  </View>
                )}
              </View>
            </View>
          </View>
        )}
      </View>

      <View style={styles.row}>
        <TouchableOpacity style={styles.chooseBtn}>
          <Text numberOfLines={1} style={styles.chooseText}>Choose CSV</Text>
          <input
            type="file"
            accept=".csv,text/csv"
            testID="boxcatalog-file-input"
            style={styles.hiddenInput}
            onChange={event => {
              onChooseFile(event.target.files[0]);
              event.target.value = '';
            }}
          />
        </TouchableOpacity>

        <Text numberOfLines={1} style={styles.fileName}>
          {fileName || 'No file chosen'}
        </Text>

        <TouchableOpacity
          testID="boxcatalog-upload"
          style={[styles.uploadBtn, !canUpload && styles.uploadBtnDisabled]}
          disabled={!canUpload}
          onPress={onUpload}>
          {isUploading ? (
            <ActivityIndicator size="small" color="#fff" />
          ) : (
            <Text style={styles.uploadText}>Upload</Text>
          )}
        </TouchableOpacity>

        {count !== 0 && (
          <TouchableOpacity
            testID="boxcatalog-clear-all"
            style={[styles.clearAllBtn, isClearing && styles.uploadBtnDisabled]}
            disabled={isClearing}
            onPress={() => setClearConfirmVisible(true)}>
            {isClearing ? (
              <ActivityIndicator size="small" color="#fff" />
            ) : (
              <Text style={styles.clearAllText}>Reset Box Catalog</Text>
            )}
          </TouchableOpacity>
        )}
      </View>

      <ClearBoxCatalogConfirmModal
        visible={clearConfirmVisible}
        onConfirm={() => {
          setClearConfirmVisible(false);
          onClearAll && onClearAll();
        }}
        onCancel={() => setClearConfirmVisible(false)}
      />

      {result ? (
        <Text
          testID="boxcatalog-result"
          style={[styles.result, {color: result.success ? '#7BE0A0' : '#FF9B9B'}]}>
          {result.message}
        </Text>
      ) : null}

      {result && Array.isArray(result.errors) && result.errors.length > 0 ? (
        <View testID="boxcatalog-errors" style={styles.errors}>
          {result.errors.map((e, i) => (
            <Text key={i} style={styles.errorLine}>
              • Row {e.row}: {Array.isArray(e.messages) ? e.messages.join(', ') : String(e.messages)}
            </Text>
          ))}
        </View>
      ) : null}
    </View>
  );
};

export default BoxCatalogView;

const styles = StyleSheet.create({
  card: {borderColor: '#687C90', borderWidth: 2, borderRadius: 15, padding: 18},
  heading: {fontSize: 20, fontFamily: fontFamily.font600, fontWeight: 'bold', color: '#FFFFFF', marginBottom: 10},
  count: {fontSize: 14, fontFamily: fontFamily.font300, color: '#FFFFFF', marginBottom: 22},
  row: {flexDirection: 'row', alignItems: 'center', flexWrap: 'wrap', marginTop: 24},
  chooseBtn: {borderWidth: 1, borderColor: '#FFFFFF', borderRadius: 5, paddingHorizontal: 14, paddingVertical: 6, marginRight: 12, justifyContent: 'center'},
  chooseText: {color: '#FFFFFF', fontSize: 13, fontFamily: fontFamily.font300},
  hiddenInput: {position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer'},
  fileName: {fontSize: 13, fontFamily: fontFamily.font300, color: '#FFFFFF', marginRight: 12, maxWidth: 220},
  uploadBtn: {borderWidth: 1, borderColor: '#FFFFFF', borderRadius: 5, paddingHorizontal: 18, paddingVertical: 6, minWidth: 84, alignItems: 'center'},
  uploadBtnDisabled: {borderColor: '#9aa7b3', opacity: 0.6},
  uploadText: {color: '#FFFFFF', fontSize: 13, fontFamily: fontFamily.font300},
  clearAllBtn: {borderWidth: 1, borderColor: '#FF9B9B', borderRadius: 5, paddingHorizontal: 14, paddingVertical: 6, marginLeft: 'auto', alignItems: 'center'},
  clearAllText: {color: '#FF9B9B', fontSize: 13, fontFamily: fontFamily.font300},
  result: {marginTop: 14, fontSize: 13, fontFamily: fontFamily.font600},
  errors: {marginTop: 6},
  errorLine: {color: '#FF9B9B', fontSize: 12, fontFamily: fontFamily.font300, marginTop: 2},
  // weight settings, same card — toggle + its Product-weight field grouped together
  verificationWrapper: {alignItems: 'flex-start', position: 'relative', zIndex: 21, marginBottom: 12},
  weightWrapper: {alignItems: 'flex-start', position: 'relative', zIndex: 20},
  weightRow: {flexDirection: 'row', gap: '10px', alignItems: 'center', position: 'relative', zIndex: 20},
  infoBtn: {width: 18},
  weightLabel: {color: '#FFFFFF', fontSize: 16, fontWeight: 300},
  weightSection: {flexDirection: 'row', alignItems: 'center', marginTop: 12},
  weightHeading: {color: '#c9c4c4', fontFamily: 'Poppins_300Light', fontSize: 14, fontWeight: 300, marginRight: 10},
  weightValueRow: {flexDirection: 'row', alignItems: 'center'},
  weightInput: {width: 48, height: 29, borderRadius: 10, paddingHorizontal: 10, marginLeft: 0, marginRight: 1, backgroundColor: '#e3dcdc', color: '#333', textAlign: 'center'},
  unitDropdownContainer: {marginLeft: 6, position: 'relative', zIndex: 10},
  unitDropdownButton: {
    width: 70,
    height: 29,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 6,
    borderWidth: 1,
    borderColor: 'transparent',
    borderBottomWidth: 1,
    borderBottomColor: '#fff',
    borderRadius: 5,
    backgroundColor: 'transparent',
  },
  unitDropdownText: {color: '#fff', fontSize: 14, fontFamily: fontFamily.font300},
  unitDropdownArrow: {width: 12, height: 12},
  unitDropdownPanel: {
    position: 'absolute',
    top: 32,
    left: 0,
    width: 70,
    overflow: 'visible',
    backgroundColor: '#2D445F',
    borderWidth: 2,
    borderColor: '#2D445F',
    borderRadius: 5,
    zIndex: 30,
  },
  unitDropdownOption: {height: 32, justifyContent: 'center', paddingHorizontal: 8},
  unitDropdownOptionSelected: {backgroundColor: '#336599'},
  unitDropdownOptionText: {color: '#9aafc0', fontSize: 14, fontFamily: fontFamily.font300},
  unitDropdownOptionTextSelected: {color: '#ffffff', fontFamily: fontFamily.font600},
});
